<template>
    <v-container class="px-0" fluid>

        <v-form>
            <v-card class="pa-8 ma-3">
                <v-row>
                    <v-col cols="2">
                        <v-select
                                :items="[$t(`pos.productSaleTab['Merke']`), $t(`pos.productSaleTab['Serie']`), $t(`pos.productSaleTab['Kategori']`)]"
                                :label="$t(`pos.productSaleTab['Nivå']`) + ' 1:'"
                        ></v-select>
                        <v-select
                                :items="[$t(`pos.productSaleTab['Merke']`), $t(`pos.productSaleTab['Serie']`), $t(`pos.productSaleTab['Kategori']`)]"
                                :label="$t(`pos.productSaleTab['Nivå']`) + ' 2:'"
                        ></v-select>
                    </v-col>
                    <v-col cols="3">
                        <v-checkbox :label="$t(`pos.productSaleTab['Vis kun de med data']`)" value="John"></v-checkbox>
                        <v-checkbox :label="$t(`pos.productSaleTab['Vis kun aktive']`)" value="John"></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-select
                                :items="[$t(`pos.productSaleTab['Ikke overstyr ansatt']`)]"
                                :label="$t(`pos.productSaleTab['Overstyr ansatt ved varesalg for varer i oppgjørgruppe 1 til']`)"
                        ></v-select>
                        <v-select
                                :items="[$t(`pos.productSaleTab['Ikke overstyr ansatt']`)]"
                                :label="$t(`pos.productSaleTab['Overstyr ansatt ved varesalg for varer i oppgjørgruppe 2 til']`)"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-btn color="success" class="mr-4"> {{ $t(`Lagre`) }}</v-btn>
                <v-btn color="error" class="mr-4"> {{ $t(`Avbryt`) }}</v-btn>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
   export default {
      data () {
         return {
            radioGroup: '1'
         }
      },
      name: 'pos-sale'
   }
</script>

<style scoped>

</style>
